import React from 'react';

export const Diamond = ({ custom }) => {
  return (
    <div className="diamond-part" style={custom}>
      <div className="diamond-bg"></div>
    </div>
  )
}
